import { Button, Toolbar } from "@material-ui/core";
import Pathnames from "../../model/enum/Pathnames";
import { useNavigate } from "react-router-dom";
import NotificationIcon from "../../assets/admin/notifications-icon.svg";
import GoogleMeetIcon from "../../assets/admin/google-meet-icon.svg";
import PhoneIcon from "../../assets/admin/phone-icon.svg";
import ActivitiesIcon from "../../assets/admin/recent-activities-icon.svg";
import Avatar from "../../shared/components/images/Avatar";
import ProfileIcon from "../../assets/admin/profile-icon.svg";
import SearchInput from "../../shared/components/search/SearchInput";
import useStyles from "./styles";
import SearchSelect from "../../shared/components/search/SearchSelect";

const Navbar = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const userName = localStorage.getItem("userName");

  return (
    <>
      <div className={classes.appBar}>
        <Toolbar className={classes.toolBarDiv}>
          <SearchSelect classes={classes} />
          <div className={classes.leftDiv}>
            {/* TODO */}
            {/* <div className={classes.callDiv}>
                  <Button>
                    <img src={GoogleMeetIcon} alt="meet icon" />{" "}
                  </Button>
                  <Button>
                    <img src={PhoneIcon} alt="phone icon" />
                  </Button>
                </div> */}
            <div className={classes.otherDiv}>
              {/* <Button>
                <img src={ActivitiesIcon} alt="activities icon" />
              </Button>
              <Button>
                <img src={NotificationIcon} alt="notification icon" />
              </Button> */}
              <Button onClick={() => navigate(Pathnames.PROFILE)}>
                {userName ? (
                  <Avatar name={userName} size={25} fontSize={12} />
                ) : (
                  <img src={ProfileIcon} alt="profile icon" />
                )}
              </Button>
            </div>
          </div>
        </Toolbar>
      </div>
    </>
  );
};

export default Navbar;
